const LoadingScreen = ({ style = {} }) => (
  <div className="min-h-screen flex flex-col justify-center items-center" style={style}>
    <div className="relative w-16 h-16">
      <div className="absolute inset-0 rounded-full border-[3px] border-gray-100" />
      <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-[#1845a3] border-r-[#ED1C24] animate-spin" />
      <div className="absolute inset-2 rounded-full border-[2px] border-transparent border-b-[#1845a3]/40 border-l-[#ED1C24]/40 animate-spin" style={{ animationDirection: "reverse", animationDuration: "0.8s" }} />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-3 h-3 rounded-full bg-gradient-to-br from-[#1845a3] to-[#ED1C24] animate-pulse" />
      </div>
    </div>
    <p className="mt-4 text-xs font-medium text-gray-400 animate-pulse">Loading...</p>
  </div>
);

export default LoadingScreen;
